import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { IconButton } from '@mui/material';
import type { ReactElement } from 'react';

import type { SlabDragControl } from '../../../SlabDraggableList/SlabDraggableList';

type ColumnDragHandleProps = {
  dragControls: SlabDragControl;
};

export const ColumnDragHandle = ({ dragControls }: ColumnDragHandleProps): ReactElement => (
  <IconButton size='small' {...dragControls} sx={{ cursor: 'grab', color: 'action.active' }}>
    <DragIndicatorIcon fontSize='small' />
  </IconButton>
);
